import { BrowserRouter } from 'react-router-dom';
import NavigationRouting from './component/NavigationRouting';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/assest/css/fonts.css';
import '../src/assest/css/style.css';

function App() {
  return (
    <BrowserRouter>
    <NavigationRouting/>
    </BrowserRouter>
  );
}

export default App;
